export const gehaThemeOverride = {
  theme: {
    colors: {
      tint1: '$core.color.brand.20',
      tint2: '$core.color.brand.20',
      tint3: '#E3D4F5',
      pastel1: '$core.color.aqua.15',
      pastel3: '$core.color.aqua.15',
      pastel4: '$core.color.aqua.15',
      infoFooterBackground: '#E8E9F3',
      uhcPrimary1: '#002677',
      lightGray: '#D0D0D0',
      cardBorder: '#E5E5E5',
      neutralGray: '$core.color.neutral.80',
      neutralGray2: '#F2F2F2',
      neutralGray5: '#6E7072',
      descriptionBlack: '#19191A',
      neutralGray7: '$core.color.neutral.90',
      neutralGray4: '$core.color.neutral.30',
      starBorder: '#D2800F',
      bgHeaderColor: '#FBFCFE',
      icColor: '$core.color.neutral.90',
      tcolor: '$core.color.brand.60',
      bgProviderDetailsColor: '$bgHeaderColor',
      tabsContainerBackgroundColor: '#FAFAFA',
      tabButtonBackgroundColor: '#FAFAFA',
      tabSelectionTextColor: '$core.color.brand.100',
      mapViewContainerBgColor: 'white',
      whereToGetHelpCardBg1: '$core.color.brand.5',
      whereToGetHelpCardBg2: '#FCF6F1',
      whereToGetHelpCardBg3: '$core.color.aqua.15',
      tabNotSelectedTextColor: '$core.color.brand.60',
      snackCardAvatarBackgroundColor: '#EEF8FB',
      milesTextColor: '$core.color.brand.60',
      headerCardWrapperBorderColor: '$cardBorder',
      virtualVisitIconColor: '$core.color.brand.100',
      searchBorderColor: '#E5E5E5',
      recentVisitCardSliderBg: 'white',
      memberInitialsBgColor: '$core.color.brand.60',
      memberInitialsTextColor: 'white',
      pageBodyBgColor: 'white',
      providerDetailsDrawerHeaderBgColor: '$core.color.brand.100',
      providerDetailsDrawerHeaderLoadingBgColor: '$core.color.brand.100',
      providerDetailsDrawerHeaderTextColor: '$core.color.neutral.0',
      providerDetailsDrawerHeaderHighlightColor: '$core.color.neutral.0',
      providerDetailsDrawerHeaderInNetworkStatusIconColor:
        '$core.color.neutral.0',
      providerDetailsDrawerHeaderInNetworkStatusLabelColor:
        '$core.color.neutral.0',
      providerDetailsDrawerLocationsDropdownOptionColor:
        '$core.color.brand.100',
      searchIconColor: '#323333',
      errorTextColor: '#C40000',
      notificationColor: '#002677',
      notificationInteractiveColor: '#196ECF',
      refreshIconColor: '$core.color.brand.100',
      subTextcolor: '$uhcPrimary1',
      orText: '#424242',
      facilitynameTextColor: '#1C0950',
    },
    fontSizes: {
      xs: '12.64px',
      extraSmall: '12.64px',
      extraSmallText: '12.64px',
      sm: '14.24px',
      small: '14.24px',
      smallText: '14.24px',
      md: '16px',
      medium: '20.25px',
      mediumText: '20.25px',
      lg: '18px',
      large: '25.63px',
      largeText: '25.63px',
      dateInfoText: '12.64px',
      providerDetailsDrawerBHFooterTimeStampText: 'md',
      providerDetailsDrawerBHFooterDateText: 'md',
    },
    fontWeights: {
      medium: '500',
      memeberInitialsFW: '500',
      providerDetailsDrawerHeaderInNetworkFW: 'medium',
      providerDetailsDrawerBHFooterDateFW: 'medium',
    },
    lineHeights: {
      lg: '24px',
      xl: '32px',
      md: '20px',
      sm: '16px',
    },
    space: {
      wrapperPadding: '24px 0',
      headerWrapperPadding: '24px 0',
      tabButtonsPadding: '5px 0 5px 0',
      recentSearchBottomGap: '8px',
      recentActivityTopPadding: '24px',
      popoverContainerTop: '3px',
      lg: '24px',
      md: '16px',
      sm: '8px',
      xs: '4px',
    },
    borderWidths: {
      recentActivityBorder: '1px',
    },
    sizes: {
      iconBrandSize: '72px',
      dataCardForMapIconSize: '49px',
      dataCardIconSize: 49,
      snackCardIconSize: 72,
      snackCardIconMobileSize: 60,
      detailsIconSize: 84,
      compareAndShareIconSize: 64,
      recentVisitSnackcardIconSize: 56,
      detailsWidgetHeaderIconSize: 84,
      choosePCPLocationIconSize: 42,
      confirmPCPLocationIconSize: 42,
      choosePCPSuccessIconSize: 45,
    },
    fonts: {
      primary: 'AbyssUHCSans, Arial, sans-serif',
      heading: 'AbyssUHCSerif, Georgia Bold, serif',
    },
  },
};
